import { takeEvery, all } from 'redux-saga/effects';

import * as actionTypes from '../actions/actionTypes';
import { logoutSaga, authUserSaga, authCheckStateSaga } from './auth';
import { getSitesSaga, setFavoriteSiteSaga, setSiteSelectedSaga, getSiteDataSaga, getOOSUnitsSaga } from './site';
import { reportIssueSaga } from './issue';

export function* watchAuth() {
    yield all([
        takeEvery(actionTypes.AUTH_INITIATE_LOGOUT, logoutSaga),
        takeEvery(actionTypes.AUTH_USER, authUserSaga),
        takeEvery(actionTypes.AUTH_CHECK_STATE, authCheckStateSaga)
    ]);
}

export function* watchSite() {
    yield all([
        takeEvery(actionTypes.GET_SITES, getSitesSaga),
        takeEvery(actionTypes.SET_SITE_SELECTED, setSiteSelectedSaga),
        takeEvery(actionTypes.SET_FAVORITE_SITE, setFavoriteSiteSaga),
        takeEvery(actionTypes.GET_SITE_DATA, getSiteDataSaga),
        takeEvery(actionTypes.GET_OOS_UNITS, getOOSUnitsSaga)
    ]);
}

export function* watchIssue() {
    yield all([
        takeEvery(actionTypes.REPORT_ISSUE, reportIssueSaga)
    ]);
}